import React from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { useAuth, useLinks } from "hooks";
import missionTimeGradient from "assets/images/mission-time-gradient.png";
import { TeamTimeSheetChart } from "components/Missions/TimeSheets";
import { margins } from "style";
import { colors } from "style";
import { Header } from "components/DisplayBox";
import { H3 } from "components/Text";
import { PrimaryLink } from "components/Links";
import { Spinner } from "components/Loader";

/**
 * TimeSheetSummary
 */
const TimeSheetSummary = () => {
  const todayMonth = moment().format("MMMM");
  const { teams, isLoading, isAuthenticated } = useAuth();
  const links = useLinks();

  if (isLoading) return <Spinner />;
  if (!isAuthenticated) return null;

  return (
    <>
      <StyledHeader marginSize={margins.normal} noUnderline>
        <H3>Time Sheets for {todayMonth}</H3>
        <PrimaryLink to={links.time_sheet} withMoreIcon>
          <FormattedMessage id="Missions.TimeSheets.TimeSheetSummary.CompleteLink" />
        </PrimaryLink>
      </StyledHeader>
      <div css={styles.container}>
        {teams.map((team) => (
          <div key={team?.name} css={styles.item}>
            <TeamTimeSheetChart team={team} />
          </div>
        ))}
      </div>
    </>
  );
};

const StyledHeader = styled(Header)`
  margin-bottom: 0;
`;

const styles = {
  container: css`
    display: flex;
    gap: 3rem;
    padding-bottom: 3.2rem;
    margin-bottom: 3.2rem;
    flex-wrap: wrap;
    border-bottom: 1px ${colors.grayAnatomyLight3} solid;
  `,
  item: css`
    flex: 1;
    min-width: 30rem;
  `,
  image: css`
    margin: 0 1.6rem;
    background-image: url(${missionTimeGradient});
    min-height: 6.4rem;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2.4rem;
  `,
  title: css`
    font-size: 1.8rem;
    font-weight: 500;
    line-height: 1.33;
    color: ${colors.white};
  `,
};

export default TimeSheetSummary;
